import Stripe from "stripe";
const stripe = new Stripe(process.env.STRIPE_SECRET_KEY as string, {
  apiVersion: "2020-08-27",
});
import { ChangeEvent, SyntheticEvent, useEffect, useState } from "react";
import { useDebounce } from "react-use";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "./donation-checkout-form";
import ArrowLeftIcon from "./assets/arrow-left-icon";
import Router from "next/router";

const stripePromise = loadStripe(
  process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY as string
);

const calculateProcessingFees = (amount: number) => {
  return Math.ceil((amount / 100) * 0.022 + 0.3) * 100;
};

interface DonationFormProps {
  prices: any[];
}

export default function DonationForm({ prices }: DonationFormProps) {
  const initialPrice = prices.filter((p) => p.type === "one_time")[0] || 0;
  const [selected, setSelected] = useState("price_1LAbDgJuSJptrU3HMZV5i9qX");
  const [clientSecret, setClientSecret] = useState("");
  const [otherAmount, setOtherAmount] = useState("");
  const [coverFees, setCoverFees] = useState(true);
  const [processingFees, setProcessingFees] = useState(
    calculateProcessingFees(initialPrice.unit_amount)
  );
  const [amount, setAmount] = useState(initialPrice.unit_amount);

  useEffect(() => {
    // Check to see if this is a redirect back from Checkout
    // const query = new URLSearchParams(window.location.search);
    const cs = new URLSearchParams(window.location.search).get(
      "payment_intent_client_secret"
    );

    setClientSecret(cs || "");
    // if (query.get("success")) {
    //   console.log("Order placed! You will receive an email confirmation.");
    // }

    // if (query.get("canceled")) {
    //   console.log(
    //     "Order canceled -- continue to shop around and checkout when you’re ready."
    //   );
    //   const cookies = parseCookies();
    //   console.log(`cookies:`, cookies);
    //   const participants = JSON.parse(cookies.participants);
    //   console.log(`participants:`, participants);
    // }
  }, []);

  useDebounce(
    () => {
      if (otherAmount) {
        const other = parseInt(otherAmount, 10) * 100;
        setAmount(other);
        const pf = calculateProcessingFees(other);
        setProcessingFees(pf);
        // if (coverFees) {
        //   updateIntent(other + pf);
        // } else {
        //   updateIntent(other);
        // }
      }
    },
    500,
    [otherAmount]
  );

  const handlePriceSelection = async (price: any) => {
    setSelected(price.id);
    setAmount(price.unit_amount);
    const pf = calculateProcessingFees(price.unit_amount);
    setProcessingFees(pf);
  };

  const handleOtherSelection = async () => {
    setSelected("other");
    if (otherAmount) {
      const other = parseInt(otherAmount, 10) * 100;
      setAmount(other);
      const pf = calculateProcessingFees(other);
      setProcessingFees(pf);
    }
  };

  const updateIntent = async (amount: number) => {
    const res = await fetch("/api/update-payment-intent", {
      method: "POST",
      body: JSON.stringify({
        clientSecret,
        amount,
      }),
    });
    const data = await res.json();
    setAmount(data.amount);
  };

  const handleCoverFeesChecked = async (e: ChangeEvent<HTMLInputElement>) => {
    const cover = e.target.checked;
    setCoverFees(cover);
    // setProcessingFees(calculateProcessingFees(amount));
    if (!cover) {
      await updateIntent(amount - processingFees);
    } else {
      await updateIntent(amount + processingFees);
    }
  };

  const handleBackClick = async () => {
    // const res = await fetch("/api/cancel-payment-intent", {
    //   method: "post",
    //   headers: { "Content-Type": "application/json" },
    //   body: JSON.stringify({ clientSecret }),
    // });

    setClientSecret("");
    Router.replace("/donate");
  };

  const handleSubmit = async () => {
    const res = await fetch("/api/create-donation-intent", {
      method: "post",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        amount: coverFees ? amount + processingFees : amount,
      }),
    });
    const data = await res.json();
    setClientSecret(data.clientSecret);
    setAmount(data.amount);
  };

  return (
    <div className="flex flex-col lg:min-h-screen lg:flex-row w-full justify-center pt-16">
      <div className="mb-10 justify-center items-center lg:flex-1 md:p-10">
        {!clientSecret && (
          <>
            <div className="max-w-[500px] mx-auto pl-4">
              <span>Select Donation Amount:</span>
            </div>
            <div
              className="flex justify-between m-auto p-4"
              style={{ maxWidth: "500px" }}
            >
              {prices
                .filter((p: any) => p.type === "one_time")
                .map((price: any) => {
                  return (
                    <div
                      key={price.id}
                      onClick={() => handlePriceSelection(price)}
                      className={`rounded-md mb-4 p-3 hover:bg-primary hover:text-white hover:cursor-pointer ${
                        selected === price.id
                          ? "bg-primary text-white"
                          : "bg-white text-black"
                      }`}
                      style={{
                        border: "1px solid rgba(50, 50, 93, 0.1)",
                        boxShadow:
                          "0px 1px 1px rgb(0 0 0 / 3%), 0px 3px 6px rgb(0 0 0 / 2%)",
                      }}
                    >
                      <h1>${price.unit_amount / 100}</h1>
                    </div>
                  );
                })}
              <div
                onClick={handleOtherSelection}
                className={`rounded-md mb-4 p-3 hover:bg-primary hover:text-white hover:cursor-pointer ${
                  selected === "other"
                    ? "bg-primary text-white"
                    : "bg-white text-black"
                }`}
                style={{
                  border: "1px solid rgba(50, 50, 93, 0.1)",
                  boxShadow:
                    "0px 1px 1px rgb(0 0 0 / 3%), 0px 3px 6px rgb(0 0 0 / 2%)",
                }}
              >
                <h1>Other</h1>
              </div>
            </div>
            {selected === "other" && (
              <div className="w-full max-w-[500px] mx-auto px-4">
                <input
                  id="otherAmount"
                  type="number"
                  value={otherAmount}
                  placeholder="$0"
                  onChange={(e) => setOtherAmount(e.target.value)}
                  className="rounded-md mb-4 p-3 bg-white w-full"
                  style={{
                    border: "1px solid rgba(50, 50, 93, 0.1)",
                    maxHeight: 44,
                    boxShadow:
                      "0px 1px 1px rgb(0 0 0 / 3%), 0px 3px 6px rgb(0 0 0 / 2%)",
                  }}
                />
              </div>
            )}
            <div className="w-full max-w-[500px] mx-auto px-4 mt-4">
              <button
                type="submit"
                role="link"
                className="w-full btn"
                onClick={handleSubmit}
              >
                Proceed to Payment Information
              </button>
            </div>
          </>
        )}
        {clientSecret && (
          <div>
            <button
              className="flex mb-4 items-center rounded-lg hover:bg-gray-100 p-1 ml-2"
              onClick={handleBackClick}
            >
              <ArrowLeftIcon className="mr-2 w-5 h-5" /> Back
            </button>
            <Elements options={{ clientSecret }} stripe={stripePromise}>
              <CheckoutForm
                onCoverFeesChecked={handleCoverFeesChecked}
                coverFees={coverFees}
                processingFees={processingFees}
                amount={amount}
              />
            </Elements>
          </div>
        )}
      </div>
      <div className="flex flex-col lg:flex lg:flex-1 bg-neutral z-0">
        <div className="bg-neutral p-8 lg:min-h-full relative">
          <div className="flex flex-col items-center lg:sticky lg:top-[20%]">
            <h1 className="text-primary font-bold text-3xl mb-4 text-center">
              A Gift that Give Back
            </h1>
            <h2 className="text-gray-800 text-xl mb-4 text-center">
              Donate Today in Order to Make an Impact on Supporting Breast
              Cancer Clinical Trials, Education and Patient Care
            </h2>
            <div>
              <div className="mt-20 mb-4 text-gray-600">
                <h4 className="font-semibold">
                  This is what your donation does:
                </h4>
              </div>
              <ul className="list-disc list-outside ml-4">
                <li className="mb-2">
                  Assists breast cancer clinical trial patients with the added
                  cost for transportation, meals and child care (Patients may
                  have extra visits to carefully monitor the side effects and
                  safety while participating in a clinical trial).
                </li>
                <li className="mb-2">
                  Provide educational opportunities for breast cancer physicians
                  to increase their knowledge on current clinical trials and
                  research by attending a conference or symposium.
                </li>
                <li className="mb-2">
                  Educate the general public (corporations, community groups and
                  college students) on breast cancer prevention, detection,
                  treatment and clinical trials.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
